import { useState } from "react";
import { FiltersInterface } from "../config/consts";

type EnumerableValues<T> = T extends Array<infer R> ? R : never;
type ToggleableOptions<T> = T extends EnumerableValues<FiltersInterface[keyof FiltersInterface]>
  ? T
  : never;

// Toggles local state in Trade History filters only if filter state is enumerable
// E.g. Token, Network, Transaction (not Amount)

export const useTradeHistoryFilterToggle = <T,>() => {
  const [localOptions, setLocalOptions] = useState<Array<ToggleableOptions<T>> | undefined>(
    undefined
  );

  const toggleLocalOptions = (filterId: ToggleableOptions<T>) => {
    let updatedLocalOptions = localOptions;
    if (updatedLocalOptions?.includes(filterId)) {
      updatedLocalOptions = updatedLocalOptions.filter(option => option !== filterId);
    } else {
      updatedLocalOptions = localOptions ? [...localOptions, filterId] : [filterId];
    }
    if (updatedLocalOptions.length === 0) {
      setLocalOptions(undefined);
    } else {
      setLocalOptions(updatedLocalOptions);
    }
  };

  return { localOptions, setLocalOptions, toggleLocalOptions };
};
